import { useNotifications } from '../notifications';

export const copyToClipboard = async (
  value: string,
  options?: {
    message?: string;
    timeout?: number;
  },
): Promise<void> =>
  navigator.clipboard
    .writeText(value)
    .then(() => {
      useNotifications().nudge(options?.message || 'Copied.', {
        timeout: options?.timeout || 1000,
      });
    })
    .catch(() => {
      useNotifications().nudge('Unable to copy. Please try again.', {
        level: 'warning',
        timeout: 2000,
      });
    });
